interface NotEnoughFreeSeatsInGroupParams {
  g?: {
    max_students?: number | null;
    student_count?: number | null;
  };
  parameterForComparison?: number;
}

export const notEnoughFreeSeatsInGroup = (params: NotEnoughFreeSeatsInGroupParams): boolean => {
  const { g, parameterForComparison } = params;
  
  return (
    typeof g?.max_students === 'number' && 
    typeof g?.student_count === 'number' && 
    typeof parameterForComparison === 'number' &&
    (g.max_students - g.student_count < parameterForComparison)
  );
}